import { followingSidebar } from '../utils/sidebar.utils.js';

const searchSection = document.querySelector('.search-sec');

if (searchSection) {
  const sidebar = searchSection.querySelector('#sidebar');
  const contentSticky = searchSection.querySelector('#content-sticky');
  const filtersBtn = searchSection.querySelector('#filters-btn');
  const submitBtn = searchSection.querySelector('.submit_btn');
  const contentResult = searchSection.querySelector('#content-result');

  const isColumnTypeSec = searchSection.classList.contains('column-type');

  if (sidebar && window.innerWidth >= 852 && !isColumnTypeSec) {
    followingSidebar({ sidebar, contentSticky });
  }

  if (filtersBtn) {
    filtersBtn.addEventListener('click', () => {
      filtersBtn.classList.toggle('is-open-filters');
      sidebar.classList.toggle('is-open-filters');
      contentSticky.classList.toggle('is-open-filters');
      contentResult.classList.toggle('is-open-filters');
    });

    submitBtn?.addEventListener('click', () => {
      filtersBtn.classList.toggle('is-open-filters');
      sidebar.classList.toggle('is-open-filters');
      contentSticky.classList.toggle('is-open-filters');
      contentResult.classList.toggle('is-open-filters');
    });

    contentResult.addEventListener('click', () => {
      if (contentResult.classList.contains('is-open-filters')) {
        filtersBtn.classList.remove('is-open-filters');
        sidebar.classList.remove('is-open-filters');
        contentSticky.classList.remove('is-open-filters');
        contentResult.classList.remove('is-open-filters');
      }
    });
  }
}

/*if (document.getElementsByClassName('job-search-section__form')[0]) {
  const checkboxesTypes = document.querySelectorAll(
    'input[type="checkbox"][name="type[]"], input[type="checkbox"][name="type_second[]"]'
  );

  function syncCheckboxes(event) {
    const targetCheckbox = event.target;
    const isChecked = targetCheckbox.checked;
    const targetValue = targetCheckbox.value;

    checkboxesTypes.forEach((checkbox) => {
      if (checkbox.value === targetValue) {
        checkbox.checked = isChecked;
      }
    });
  }

  checkboxesTypes.forEach((checkbox) => {
    checkbox.addEventListener('change', syncCheckboxes);
  });

  const checkboxesSectors = document.querySelectorAll(
    'input[type="checkbox"][name="sector[]"], input[type="checkbox"][name="sector_second[]"]'
  );

  function syncCheckboxesSectors(event) {
    const targetCheckbox = event.target;
    const isChecked = targetCheckbox.checked;
    const targetValue = targetCheckbox.value;

    checkboxesSectors.forEach((checkbox) => {
      if (checkbox.value === targetValue) {
        checkbox.checked = isChecked;
      }
    });
  }

  checkboxesSectors.forEach((checkbox) => {
    checkbox.addEventListener('change', syncCheckboxesSectors);
  });
}*/
